
<template>
    <!--ToolBox -->
    <div class="toolbox box pt-0 px-2" >
        <a @click="onJsHomeReturn()" :title="$t('toolBox.accueil')">
            <img src="./../../assets/img/logo-johnsteel-editeur.png" width="55" height="55" class="mx-auto d-block mt-2 cursor-pointer">
        </a>

        <div class="position-relative">
            <b-button id="btn-cut-matter" class="px-1 mt-4 bg-gris overflow-hidden text-center d-block" :class="[toolType == 'cut' ? 'rounded-top-10' : 'rounded-10', {'disabled' : !allowCut}]" @click="selectToolType('cut')" key="btn-cut" @mouseover="overTool('cut')" @mouseleave="leaveTool()">
                <img id="icon-cut" class="h-100" :src="require('@/assets/img/remove-matter.svg')" width="50">
            </b-button>
            <div class="fly-over-tool animated slideInLeft cursor-pointer" v-if="tutoEditor == 'cut' && noShowTuto.indexOf('cut') == -1" @click="$store.dispatch('setTuto', null); noShowTuto.push('cut')" >
                <div class="rounded-right-10 p-3 shadow-pro text-left" :class="selectedShape && !selectedShape.isCut ? 'bg-rose' : 'bg-violet'">
                    <span class="text-white h5 font-weight-bold"><t toolBox.cut /></span>
                    <p class="text-white mb-0 line-height"><t toolBox.tutoCut /></p>
                </div>
            </div>
            <div class="fly-over-tool animated fadeIn" v-if="infoDisabled == 'cut'">
                <div class="rounded-10 p-3 shadow-pro bg-white d-flex align-items-center">
                    <b-icon icon="info-circle-fill" font-scale="1.5" />
                    <p class="text-dark mb-0 line-height pl-2"><t toolBox.tutoNoCut /></p>
                </div>
            </div>
        </div>

        <transition-group name="bounce">
            <div id="cut-matter" class="bg-gris-pro pt-1 pb-4 pb-md-1 d-flex justify-content-around d-md-block px-2 px-md-0 position-relative rounded-bottom-10" v-if="allowCut" key="cut">
                <div class="tool px-2 py-md-0 py-2 mx-0" @click="select('circle')">
                    <svg viewBox="-1 -1 18 18" width="100%" height="100%" focusable="false" role="img" aria-label="circle fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-circle-fill b-icon bi" style="font-size: 250%;" :class="{'tuto' : tutoEditor == 'cut' && noShowTuto.indexOf('cut') == -1}"><circle cx="8" cy="8" r="8"></circle></svg>
                </div>

                <div @click="select('rectangle')" class="tool px-2 py-2 py-md-0 mx-0">
                    <svg viewBox="-1 -1 18 18" width="100%" height="100%" focusable="false" role="img" aria-label="square fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-square-fill b-icon bi" style="font-size: 250%;" :class="{'tuto' : tutoEditor == 'cut' && noShowTuto.indexOf('cut') == -1}"><path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z"></path></svg>
                </div>

                <div @click="select('triangle')" class="tool px-2 py-2 py-md-0 mx-0">
                    <svg viewBox="-1 -1 18 18" width="100%" height="100%" focusable="false" role="img" aria-label="triangle fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-triangle-fill b-icon bi" style="font-size: 250%;" :class="{'tuto' : tutoEditor == 'cut' && noShowTuto.indexOf('cut') == -1}"><g><path fill-rule="evenodd" d="M7.022 1.566a1.13 1.13 0 0 1 1.96 0l6.857 11.667c.457.778-.092 1.767-.98 1.767H1.144c-.889 0-1.437-.99-.98-1.767L7.022 1.566z"></path></g></svg>
                </div>

                <div @click="select('text')" class="tool text px-2 py-2 py-md-0 mx-0">
                    <b-icon class="p-1" height="100%" width="100%" icon="fonts" font-scale="2.7" :class="{'tuto-text' : tutoEditor == 'cut' && noShowTuto.indexOf('cut') == -1}"/>
                </div>
            </div>
        </transition-group>

        <div v-if="!landingpage" class="position-relative">
            <b-button id="btn-add-matter" class="mt-2 p-1 bg-gris overflow-hidden d-block" :class="[{'disabled' : allowCut == null || allowCut == true}, allowCut == false ? 'rounded-top-10 rotate-90' : 'rounded-10']" @click="selectToolType('add')" key="btn-matter" @mouseover="overTool('add')" @mouseleave="leaveTool()">
                <img id="icon-add" class="h-100" :src="require('@/assets/img/add-matter.svg')" width="50">
            </b-button>
            <div class="fly-over-tool animated slideInLeft cursor-pointer" v-if="tutoEditor == 'add' && noShowTuto.indexOf('add') == -1" @click="$store.dispatch('setTuto', null); noShowTuto.push('add')">
                <div class="rounded-right-10 p-3 shadow-pro text-left" :class="!selectedShape ? 'bg-rose' : 'bg-violet'">
                    <span class="text-white h5 font-weight-bold"><t toolBox.add /></span>
                    <p class="text-white mb-0 line-height" v-if="!selectedShape"><t toolBox.tutoAdd /></p>
                    <p class="text-white mb-0 line-height" v-else><t toolBox.tutoNoAdd /></p>
                </div>
            </div>
            <div class="fly-over-tool animated fadeIn" v-if="infoDisabled == 'add'">
                <div class="rounded-10 p-3 shadow-pro bg-white d-flex align-items-center">
                    <b-icon icon="info-circle-fill" font-scale="1.5" />
                    <p class="text-dark mb-0 line-height pl-2"><t toolBox.tutoNoAdd /></p>
                </div>
            </div>
        </div>

        <transition-group v-if="!landingpage" name="bounce">
            <div id="add-matter" class="bg-gris-pro pt-1 pb-4 pb-md-1 d-flex justify-content-around d-md-block px-2 px-md-0 position-relative rounded-bottom-10" v-if="allowCut == false" key="add">
                <div class="tool px-2 py-md-0 py-2 mx-0" @click="select('circle')">
                    <b-icon height="100%" width="100%" icon="circle-fill" font-scale="2.5" :class="{'tuto' : tutoEditor == 'add' && noShowTuto.indexOf('add') == -1}" />
                </div>

                <div @click="select('rectangle')" class="tool px-2 py-2 py-md-0 mx-0">
                    <b-icon height="100%" width="100%" icon="square-fill" font-scale="2.5" :class="{'tuto' : tutoEditor == 'add' && noShowTuto.indexOf('add') == -1}" />
                </div>

                <div @click="select('triangle')" class="tool px-2 py-2 py-md-0 mx-0">
                    <b-icon height="100%" width="100%" icon="triangle-fill" font-scale="2.5" :class="{'tuto' : tutoEditor == 'add' && noShowTuto.indexOf('add') == -1}" />
                </div>

                <div @click="select('text')" class="tool text px-2 py-2 py-md-0 mx-0">
                    <b-icon class="p-1" height="100%" width="100%" icon="fonts" font-scale="2.7" :class="{'tuto' : tutoEditor == 'add' && noShowTuto.indexOf('add') == -1}" />
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import { BIcon, BIconCursorFill, BIconTrash, BIconCircleFill, BIconSquareFill, BIconInfoSquareFill, BIconFonts, BIconBoxArrowInRight, BIconBoxArrowRight, BIconStarFill, BIconTriangleFill, BIconPlus, BIconScissors, BButton, BIconInfoCircleFill }
    from 'bootstrap-vue';
    import { mapGetters } from 'vuex'

    export default {
        components: {
            BIcon,
            // eslint-disable-next-line vue/no-unused-components
            BIconCursorFill, BIconTrash, BIconSquareFill, BIconCircleFill, BIconInfoSquareFill, BIconFonts, BIconBoxArrowInRight, BIconBoxArrowRight, BIconStarFill, BIconTriangleFill, BIconPlus, BIconScissors, BButton, BIconInfoCircleFill
        },
        data() {
            return {
                landingpage: window.obelix.landingpage,
                allowCut: false,
                infoDisabled: null,
                noShowTuto: []
            }
        },

        computed: {
            ...mapGetters([
                'tool',
                'isOpenIconsModal',
                'selectedShape',
                'materialName',
                'toolType',
                'shapes',
                'pieces',
                'textFocus',
                'tutoEditor'
            ])
        },

        methods: {
            select(tool) {
                if (tool != this.tool) {
                    this.$store.dispatch('setWhiteboardTool', tool);
                } else {
                    this.$store.dispatch('setWhiteboardTool', 'selecter');
                }
            },
            async onJsHomeReturn(){
                if(window.obelix.onJsHomeReturn) window.obelix.onJsHomeReturn();
            },
            overTool(toolType) {
                if (toolType == 'cut' && !this.allowCut) {
                    this.infoDisabled = toolType;
                } else if (toolType == 'add' && this.allowCut == null || toolType == 'add' && this.allowCut == true) {
                    this.infoDisabled = toolType;
                }
            },
            leaveTool() {
                this.infoDisabled = null;
            }
        },

        watch: {
            selectedShape : async function(){
                if (this.selectedShape) {
                    this.$store.dispatch('setTuto', null);

                    if (this.selectedShape.isCut) {
                        this.$store.dispatch('setToolType', 'add');
                        this.$store.dispatch('setTuto', 'settings');
                        this.allowCut = null;
                    } else {
                        this.$store.dispatch('setToolType', 'cut');
                        this.allowCut = true;

                        if (this.shapes.length == 1) {
                            this.$store.dispatch('setTuto', 'cut');
                        } 
                    }

                } else {
                    this.$store.dispatch('setToolType', 'add');
                    this.allowCut = false;

                    if (this.pieces.length == 1) {
                        this.$store.dispatch('setTuto', 'add');
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    @import './../../assets/scss/_variables.scss';

    .toolbox {
        width: 75px!important;
        padding: 0.5rem;
        grid-template-columns: auto auto;
        width: 100%;
        gap: 0.5rem;
        background-color: $white;

        @media (max-width: 768px) {
            background-color: $gris;
            border-radius: 10px 10px 0 0;
        }

        .fly-over-tool {
            position: absolute;
            left: 61px;
            width: 350px;
            top: -5px;
            padding: 5px 10px;
            z-index: -1;

            &:after {
                position: absolute;
                content: 'x';
                width: 25px;
                height: 25px;
                color: white;
                font-weight: bold;
                top: 5px;
                right: 3px;
            }

            &.fadeIn {
                left: 75px;

                .b-icon {
                    fill: $jaune!important;
                }

                &:after {
                    content: "";
                    width: 0px;
                    height: 0px;
                    border-top: 15px solid transparent;
                    border-right: 15px solid #fff;
                    border-bottom: 15px solid transparent;
                    border-left: 15px solid transparent;
                    top: 20px;
                    left: -16px;
                    position: absolute;
                }
            }
        }

        .tool {
            color: $dark;
            margin: 7px;
            border-radius: 10px;
            text-align: center;
            position: relative;
            cursor: pointer;

            &.text {
                svg {
                    fill: #6c757d;
                    stroke: #6c757d;
                    stroke-width: 1px!important;
                }

                &:hover {
                    svg {
                        fill: $jaune!important;
                        stroke: $jaune!important;
                    }
                }

                &.active {
                    svg {
                        fill: $jaune!important;
                        stroke: $jaune!important;
                    }
                }
            }

            > svg {
                background-color:$color-select;
                padding: 8px;
                border-radius: 10px;
            }
        }

        svg {
            transition: all .1s ease-in-out;
        }

        #btn-add-matter,
        #btn-cut-matter {
            height: 59px;
            position: relative;
            transition: all .2s ease-in-out;
            cursor: pointer;
            background: $gris!important;

            .new {
                background: $jaune;
                position: absolute;
                color: white;
                font-weight: bold;
                top: 5px;
                right: -18px;
                padding: 0 19px;
                font-size: 80%;
                transform: rotate(45deg);
                transition: all .2s ease-in-out;
            }

            @media (pointer: fine) {
                &:hover:not(.disabled) {
                    .new {
                        transform: rotate(90deg) translateY(-30px);
                    }
                    svg {
                        transform: scale(1.05) rotate(90deg);
                    }
                }
            }

            &.disabled {
                cursor: not-allowed;
            }
        }

        #btn-add-matter {
            svg {
                fill: #6c757d!important;
                stroke: white;
            }
        }

        #btn-cut-matter {
            &.rotate-90 {
                img {
                    transform: scaleX(-1) rotate(270deg);
                }
            }

            img {
                transition: all .3s ease-in-out;
            }
        }

        #add-matter {
            svg {
                fill: #6c757d;
                stroke-width: 0;

                &.tuto, &.tuto path {
                    animation-name: breathe-fill;
                    animation-duration: 3s;
                    animation-iteration-count: infinite;
                    animation-delay: 1s;
                }
            }

            .tool {
                &:hover {
                    svg {
                        fill: $jaune!important;
                    }
                }

                &.active {
                    @media (max-width: 768px) {
                        background-color: $grispro;
                    }
                    svg {
                        fill: $jaune!important;
                    }
                }
            }
        }

        #cut-matter {
            svg {
                fill: $color-select;
                stroke: #6c757d;
                stroke-width: 2px;

                &.tuto {
                    animation-name: breathe;
                    animation-duration: 3s;
                    animation-iteration-count: infinite;
                    animation-delay: 1s;
                }
                &.tuto-text {
                    animation-name: breathe-fill;
                    animation-duration: 3s; 
                    animation-iteration-count: infinite;
                    animation-delay: 1s;
                }
            }

            .tool {
                &:hover {
                    svg {
                        stroke: $jaune!important;
                    }
                }

                &.active {
                    @media (max-width: 768px) {
                        background-color: $grispro;
                    }
                    svg {
                        stroke: $jaune!important;
                    }
                }

                &.text {
                    svg {
                        fill: #6c757d;
                    }
                }
            }
        }

        .show-info {
            position: absolute;
        }
    }

    .title-rounded {
        border-radius: 10px 10px 10px 0;
    }

    .content-rounded {
        border-radius: 10px;

        @media (max-width: 768px) {
            border-radius: 10px 0 0 0!important;
        }
    }

    .svg-inline--fa {
        font-size: 20px;
        cursor: pointer;
        height: 20px;
        width: 20px;
    }

    #remove-matter {
        svg {
            fill: $white;
        }
    }

    .rotate-90 {
        svg {
            transform: rotate(90deg);
        }
    }

    @keyframes breathe { 
        0% { stroke: #6c757d; } 
        25% { 
            stroke: #ffb400;
            transform: scale(1.1); } 
        60% { stroke: #6c757d; } 
        100% { stroke: #6c757d; } 
    }
    @keyframes breathe-fill { 
        0% { 
            fill: #6c757d;
            stroke: #6c757d; } 
        25% { 
            fill: #ffb400;
            stroke: #ffb400;
            transform: scale(1.05); } 
        60% { 
            fill: #6c757d;
            stroke: #6c757d; } 
        100% { 
            fill: #6c757d;
            stroke: #6c757d; } 
    }
</style>
